import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { IllegalDailyComplaint } from "./IllegalDailyComplaint";



export const IllegalGroupAttendance = () => {

    const { t } = useTranslation()
    const navigate = useNavigate();

    return (
        <>
            <div className="col-12 col-lg-12 col-xl-3 ps-xl-4 ">
                <div className="row my-2">
                    <div className="col-12 bg-white rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                        <div className="row">

                            <div className="col-12 col-md-12 pb-3 pt-2">

                                <div className="py-4 mt-3 border border-danger rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                    <div className="row text-center">

                                        <div className="col-12 col-md-6 col-lg-12  border-end">
                                            <div className="row ">
                                                <div className="col-12 ps-5 text-start cursor-pointer"
                                                    onClick={() => navigate('/GroupAttendanceIllegalGrid')}
                                                >
                                                    <span className=" fw-bold text-dark">
                                                        {/* Group Attendance */}
                                                        {t('EncroachmentDashboard.GroupAttendance')}
                                                    </span>
                                                    <i className="fa-solid fa-group-arrows-rotate text-danger cursor-pointer ps-4"></i>

                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <hr className="text-danger my-2" />

                                <div className="py-4 mt-2 border  border-danger rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                    <div className="row text-center">

                                        <div className="col-12 col-md-6 col-lg-12  border-end">
                                            <div className="row ">
                                                <div className="col-12 ps-5 text-start cursor-pointer"
                                                    onClick={() => navigate('/VehicleTrackingIllegalGrid')}
                                                >
                                                    <span className=" fw-bold text-dark">{t('EncroachmentDashboard.VehicleTracking')}</span>
                                                    <i className="fa-solid fa-map-location-dot text-danger cursor-pointer ps-4"></i>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                     </div>
                    </div>
                </div>


                {/* Daily Complaint */}
                <IllegalDailyComplaint />

            </div>

        </>

    )
}